"use client"
import { Home, X } from "lucide-react"
import { Button } from "../Button"

export default function CommercialEventSuccess({ formData, onClose }) {
  // Log all collected data
  console.log("All form data:", formData)

  return (
    <div className="p-6 flex flex-col items-center text-center">
      <div className="absolute top-4 right-4">
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700" aria-label="Close">
          <X size={20} />
        </button>
      </div>

      <div className="w-24 h-24 mb-6 relative">
        <div className="absolute bottom-0 right-0 w-10 h-10 bg-[#7B189F] rounded-full flex items-center justify-center">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.6663 5L7.49967 14.1667L3.33301 10"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="absolute top-0 left-0 w-16 h-16 bg-red-500 rounded-full flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 10.6667V16M16 21.3333H16.0133M29.3333 16C29.3333 23.3638 23.3638 29.3333 16 29.3333C8.63621 29.3333 2.66667 23.3638 2.66667 16C2.66667 8.63621 8.63621 2.66667 16 2.66667C23.3638 2.66667 29.3333 8.63621 29.3333 16Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="absolute top-0 right-0 w-12 h-12 bg-yellow-400 rounded-full"></div>
      </div>

      <h2 className="text-2xl font-bold mb-4">Thank you!</h2>
      <p className="text-gray-600 mb-8">
        One of our team members will connect
        <br />
        with you soon to assist further.
      </p>

      <Button
        onClick={onClose}
        className="flex items-center justify-center text-[#7B189F] bg-transparent hover:bg-[#7B189F]/5"
      >
        <Home size={18} className="mr-2" />
        Back to Home
      </Button>
    </div>
  )
}
